import React, { useState } from 'react';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { V1Table as Table } from '@uhg-abyss/web/ui/Table';

import CustomeRowAdd from '../CustomeRowAdd';
import { useSelector } from 'react-redux';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { TextInputArea } from '@uhg-abyss/web/ui/TextInputArea';
import { useForm } from '@uhg-abyss/web/hooks/useForm';

const AddPopulationExclusion = () => {
  const form = useForm();
  const list = useSelector((item) => item?.listOfValues?.data);
  const router = useRouter();
  const options = form?.watch('populationExclusions');
  const initialState = {
    PlanVariationCodeField: Array.isArray(options?.PlanVariationCodeField)
      ? options?.PlanVariationCodeField?.join(' ')
      : options?.PlanVariationCodeField,
    ReportingCodeField: Array.isArray(options?.ReportingCodeField)
      ? options?.ReportingCodeField?.join(' ')
      : options?.ReportingCodeField,
    MemberUtilityTextField: Array.isArray(options?.MemberUtilityTextField)
      ? options?.MemberUtilityTextField?.join(' ')
      : options?.MemberUtilityTextField,
    EligibilityUtilityTextField: Array.isArray(
      options?.EligibilityUtilityTextField
    )
      ? options?.EligibilityUtilityTextField?.join(' ')
      : options?.EligibilityUtilityTextField,
    CoverageUtilityField: Array.isArray(options?.CoverageUtilityField)
      ? options?.CoverageUtilityField?.join(' ')
      : options?.CoverageUtilityField,
  };
  const [formData, setFormData] = useState(initialState);

  const cancelReasonField = [
    {
      value: 'blank',
      label: '<blank>',
    },
    {
      value: 'CO',
      label: 'CO',
    },
    {
      value: 'NC',
      label: 'NC',
    },
    {
      value: 'NS',
      label: 'NS',
    },
    {
      value: 'TC',
      label: 'TC',
    },
    {
      value: 'TT',
      label: 'TT',
    },
    {
      value: 'TY',
      label: 'TY',
    },
    {
      value: 'TU',
      label: 'TU',
    },
  ];

  const eligibilityCHeckOptions = [
    {
      value: 'A',
      label: 'A',
    },
    {
      value: 'R',
      label: 'R',
    },
    {
      value: 'S',
      label: 'S',
    },
  ];
  const typeCodeFireld = [
    {
      value: 'D',
      label: 'D',
    },
    {
      value: 'E',
      label: 'E',
    },
    {
      value: 'EX',
      label: 'EX',
    },
    {
      value: 'GX',
      label: 'GX',
    },
    {
      value: 'HX',
      label: 'HX',
    },
    {
      value: 'JX',
      label: 'JX',
    },
    {
      value: 'KX',
      label: 'KX',
    },
    {
      value: 'L',
      label: 'L',
    },
    {
      value: 'M',
      label: 'M',
    },
    {
      value: 'MC',
      label: 'MC',
    },
    {
      value: 'ME',
      label: 'ME',
    },
    {
      value: 'MH',
      label: 'MH',
    },
    {
      value: 'MS',
      label: 'MS',
    },
    {
      value: 'NX',
      label: 'NX',
    },
    {
      value: 'RX',
      label: 'RX',
    },
    {
      value: 'S',
      label: 'S',
    },
    {
      value: 'V',
      label: 'V',
    },
  ];
  const isCopy = router?.getLocation()?.pathname?.includes('/copy');
  const handleChange = (name, e) => {
    setFormData({ ...formData, [name]: e?.target?.value });
    form.setValue(`populationExclusions.${name}`, e?.target?.value);
  };
  return (
    <Layout.Group
      css={{
        alignItems: 'start',
        '.abyss-table-cell': {
          paddingTop: '2px',
          paddingBottom: '2px',
        },
      }}
      grow
    >
      <Table.Container title="">
        <Table.TableHeader>
          <Table.TableHeaderRow>
            <Table.Column>Category</Table.Column>
            <Table.Column>Assigned Rule</Table.Column>
          </Table.TableHeaderRow>
        </Table.TableHeader>
        <Table.TableBody>
          <CustomeRowAdd
            model="populationExclusions.Type[0]"
            label="Population Exclusions Apply To"
            options={list?.popRuleExclTypes}
            type={'select'}
            placeHolder=""
          />
          {isCopy && (
            <>
              <Table.Row>
                <Table.Cell>
                  <strong>PlanVariationCodeField</strong>
                </Table.Cell>
                <Table.Cell>
                  <TextInputArea
                    label=""
                    value={formData.PlanVariationCodeField}
                    onChange={(e) => handleChange('PlanVariationCodeField', e)}
                    isClearable={false}
                  />
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  <strong>ReportingCodeField</strong>
                </Table.Cell>
                <Table.Cell>
                  <TextInputArea
                    label=""
                    value={formData.ReportingCodeField}
                    onChange={(e) => handleChange('ReportingCodeField', e)}
                    isClearable={false}
                  />
                </Table.Cell>
              </Table.Row>
            </>
          )}
          {!isCopy && (
            <>
              <CustomeRowAdd
                model="populationExclusions.PlanVariationCodeField"
                label="PlanVariationCodeField"
                type="textarea"
                placeHolder=""
              />

              <CustomeRowAdd
                model="populationExclusions.ReportingCodeField"
                label="ReportingCodeField"
                type="textarea"
                placeHolder=""
              />
            </>
          )}

          <CustomeRowAdd
            model="populationExclusions.CancelReasonField"
            label="CancelReasonField"
            type="checkboxGroup"
            options={cancelReasonField}
            placeHolder=""
          />

          <CustomeRowAdd
            model="populationExclusions.EligibilityStatusField"
            label="EligibilityStatusField"
            options={eligibilityCHeckOptions}
            type="checkboxGroup"
            placeHolder=""
          />

          <CustomeRowAdd
            model="populationExclusions.TypeCodeField"
            label="TypeCodeField"
            type="checkboxGroup"
            options={typeCodeFireld}
            placeHolder=""
          />

          {!isCopy && (
            <CustomeRowAdd
              model="populationExclusions.MemberUtilityTextField"
              label="MemberUtilityTextField"
              type="textarea"
              placeHolder=""
            />
          )}
          {isCopy && (
            <>
              <Table.Row>
                <Table.Cell>
                  <strong>MemberUtilityTextField</strong>
                </Table.Cell>
                <Table.Cell>
                  <TextInputArea
                    label=""
                    value={formData?.MemberUtilityTextField}
                    onChange={(e) => handleChange('MemberUtilityTextField', e)}
                    isClearable={false}
                  />
                </Table.Cell>
              </Table.Row>
            </>
          )}

          {!isCopy && (
            <>
              <CustomeRowAdd
                model="populationExclusions.CoverageUtilityField"
                label="CoverageUtilityTextField"
                type="textarea"
                placeHolder=""
              />

              <CustomeRowAdd
                model="populationExclusions.EligibilityUtilityTextField"
                label="EligibilityUtilityTextField"
                type="textarea"
                placeHolder=""
              />
            </>
          )}
          {isCopy && (
            <>
              <Table.Row>
                <Table.Cell>
                  <strong>CoverageUtilityField</strong>
                </Table.Cell>
                <Table.Cell>
                  <TextInputArea
                    label=""
                    value={formData?.CoverageUtilityField}
                    onChange={(e) => handleChange('CoverageUtilityField', e)}
                    isClearable={false}
                  />
                </Table.Cell>
              </Table.Row>

              <Table.Row>
                <Table.Cell>
                  <strong>EligibilityUtilityTextField</strong>
                </Table.Cell>
                <Table.Cell>
                  <TextInputArea
                    label=""
                    value={formData?.EligibilityUtilityTextField}
                    onChange={(e) =>
                      handleChange('EligibilityUtilityTextField', e)
                    }
                    isClearable={false}
                  />
                </Table.Cell>
              </Table.Row>
            </>
          )}
        </Table.TableBody>
      </Table.Container>
    </Layout.Group>
  );
};

export default AddPopulationExclusion;
